import axios, {AxiosResponse} from "axios";
import {Account, SmsRequest, TwoFactorAuthRequest, TwoFactorAuthStatusResponse, VerificationFormBe} from "./types";

export const initiateOtp = (req: TwoFactorAuthRequest): Promise<TwoFactorAuthStatusResponse>  => {
    return axios.post<object, AxiosResponse<TwoFactorAuthStatusResponse>>(`/api/launcher/2fa`, req)
        .then(r => r.data);
}

export const verifyOtp = (refCode: string, otp: string): Promise<TwoFactorAuthStatusResponse> => {
    return axios.get<any, AxiosResponse<TwoFactorAuthStatusResponse>>(`/api/launcher/2fa/${refCode}?otp=${otp}`)
        .then(r => r.data);
}

export const verifyAccount = (req: VerificationFormBe) => {
    return axios.post<any, AxiosResponse<Account>>(`/api/launcher/users/verifications`, req)
        .then(r => r.data);
}